const tutorPrefix = "/tutor";
const csmPrefix = "/csm";
const adminPrefix = "/admin";
const studentPrefix = "/student";

export const ROUTES = Object.freeze({
  CAREER: "/career",
  ABOUT: "/about",
  CONTACT: "/contact",
  PLANSPRICING: "/plans-pricing",
  PUBLICFAQ: "/publicfaq",

  FEEDBACK_DETAILS: "/feedbackdetails",
  DASHBOARD: "/dashboard",
  HOME: "/",
  REGISTER: "/register",
  ENQUIRY: "/enquiry",
  PAGES: "/dashboard/*",
  LOGIN: "/login",
  OTPLOGIN: "/otp-login",
  VERIFYOTP: "verify-otp",
  FORGOTPASSWORD: "/forgot-password",
  RESETPASSWORD: "/reset-password",
  ADD_CHILD: "/add-child",
  ADD_SUBJECT: "/add-subject",
  STUDENT_RECORDS: "/student-records",
  PROGRESS_REPORT: "/progress-report",
  ALL_SUBJECTS: "/all-subjects",
  SUBJECT_REPORT: "/subject-report",
  MAIL_US: "/mail-us",
  CHAT: "/chat",
  NEW_CHAT: "/new-chat",
  POLICIES: "/policies",
  CHANGE_TUTOR: "/change-tutor",
  REFER_FRIEND: "/refer-friend",
  REFERRAL_STATUS: "/referral-status",
  FIND_TUTOR: "/find-tutor",
  INSTALLATION: "/installation",
  SESSION_NOTES: "/session-notes",
  STUDENT_PROFILE: "/student-profile",
  PARENT_PROFILE: "/parent-profile",
  PASSWORD_RESET: "/password-reset",
  PASSWORD_RESET_SUCCESS: "/password-reset-success",
  BILLING: "/billing",
  UPDATE_BILLING: "/update-billing",
  SETTINGS: "/settings",
  VIEW_SCHEDULE: "/view-schedule",
  FAQ: "/faq",
  NOTIFICATIONS: "/notifications",
  COURSES: "/courses",
  SEARCH_RESULTS: "/search-results",
  PUBLIC_COURSES_SEARCH_RESULTS: "/view-courses",

  // student pages
  STUDENT_DASHBOARD: studentPrefix,
  STUDENT_PERSONAL_PROFILE: `${studentPrefix}/profile`,
  STUDENT_FAQ: `${studentPrefix}/faq`,

  // tutor pages
  TUTOR_DASHBOARD: "/tutor",
  UPCOMING_SESSION: `${tutorPrefix}/upcoming-session`,
  DAILY_SCHEDULE: `${tutorPrefix}/daily-schedule`,
  RESCHEDULE_SESSION: `${tutorPrefix}/reschedule-session`,
  ONLINE_LOG: `${tutorPrefix}/online-log`,
  WEEKLY_SCHEDULE: `${tutorPrefix}/weekly-schedule`,
  TUTOR_INBOX: `${tutorPrefix}/inbox`,
  TUTOR_CHAT: `${tutorPrefix}/chat`,
  TUTOR_NEW_CHAT: `${tutorPrefix}/new-chat`,
  TUTOR_PROFILE: `${tutorPrefix}/profile`,
  TUTOR_SETTINGS: `${tutorPrefix}/settings`,
  TUTOR_ONLINE_LOG_UPDATE: `${tutorPrefix}/online-log-update`,
  TUTOR_NOTIFICATIONS: `${tutorPrefix}/notifications`,
  TUTOR_REGISTER: `${tutorPrefix}/register`,
  TUTUR_PROGRESS_REPORT: `${tutorPrefix}/progress-reports`,
  TUTOR_STUDENT_REPORT: `${tutorPrefix}/student-report`,
  // csm pages
  CSM_DASHBOARD: "/csm",
  CSM_COURSE_REQUESTS: `${csmPrefix}/course-requests`,
  CSM_VIEW_PROFILE: `${csmPrefix}/view-profile`,
  CSM_STUDENT_LIST: `${csmPrefix}/student-list`,
  CSM_STUDENT_CONTACT_DETAILS: `${csmPrefix}/student-contact-details`,
  CSM_STUDENT_DETAILS: `${csmPrefix}/student-details`,
  CSM_VIEW_AVAILABLE_TUTORS: `${csmPrefix}/view-available-tutors`,
  CSM_PARENT_CONTACT: `${csmPrefix}/contact-parent`,
  CSM_PARENT_CONTACT_DETAILS: `${csmPrefix}/contact-parent-details`,
  CSM_SETTINGS: `${csmPrefix}/settings`,
  CSM_STUDENT_REPORT: `${csmPrefix}/student-report`,
  CSM_CREATE_TIME_SLOT: `${csmPrefix}/create-time-slot`,
  CSM_ASSIGN_TIME_SLOT: `${csmPrefix}/assign-time-slot`,
  CSM_ADD_SUBJECT: `${csmPrefix}/add-subject`,
  CSM_ADD_SIBLING: `${csmPrefix}/add-sibling`,
  CSM_DISPLAY_TIME_SLOT: `${csmPrefix}/display-time-slot`,
  CSM_RESCHEDULE_SESSION: `${csmPrefix}/reschedule-session`,
  CSM_SCHEDULE: `${csmPrefix}/schedule`,
  CMS_CHAT: `${csmPrefix}/chat`,
  CSM_NEW_CHAT: `${csmPrefix}/new-chat`,
  CSM_REFERRAL: `${csmPrefix}/referral`,
  CSM_REFERRAL_STATUS: `${csmPrefix}/referral-status`,
  CSM_SEARCH_RESULTS: `${csmPrefix}/search-results`,

  CSM_FEEDBACK: `${csmPrefix}/feedback`,
  CSM_LIST_TUTOR_SESSION: `${csmPrefix}/list-tutor-session`,
  CSM_LIST_MY_STUDENTS: `${csmPrefix}/list-my-students-for-a-day`,
  CSM_UPCOMING_SESSIONS: `${csmPrefix}/upcoming-sessions`,

  // admin pages
  ADMIN_DASHBOARD: adminPrefix,
  ADMIN_MANAGE_EMPLOYEE: `${adminPrefix}/manage-employee`,
  ADMIN_STUDENT_REQUESTS: `${adminPrefix}/student-requests`,
  ADMIN_MANAGE_COURSE: `${adminPrefix}/manage-course`,
  ADMIN_ADD_COURSE: `${adminPrefix}/add-course`,
  ADMIN_ADD_EMPLOYEE: `${adminPrefix}/add-employee`,
  ADMIN_CANDIDATES: `${adminPrefix}/candidates`,
  ADMIN_LIST_TUTOR_SESSION: `${adminPrefix}/list-tutor-session`,
  ADMIN_PROFILE: `${adminPrefix}/profile`,
  ADMIN_SETTINGS: `${adminPrefix}/settings`,
  ADMIN_PASSWORD_RESET_SUCCESS: `${adminPrefix}/password-reset-success`,
  ADMIN_STUDENT_REPORT: `${adminPrefix}/student-report`,

  ADMIN_CREATE_TIME_SLOT: `${adminPrefix}/create-time-slot`,
});
